import { DateTime } from 'luxon'

import { InvoiceResponseDTO } from '@core/api/dtos/response/invoice/invoice'
import { Invoice } from '@core/api/entities/invoice/invoice'
import { BillingDataMapper } from '@core/api/mappers/account/billingDataMapper'
import { InvoiceCurrencyMapper } from '@core/api/mappers/invoice/invoiceCurrencyMapper'

export class InvoiceMapper {
	static toEntity(dto: InvoiceResponseDTO): Invoice {
		return Invoice.create({
			id: dto.id,
			accountId: dto.account_id,
			billingDataId: dto.billing_data_id,
			currencyId: dto.currency_id,
			description: dto.description,
			status: dto.status,
			isDownloadable: dto.is_downloadable,
			xmlIsDownloadable: dto.xml_is_downloadable,
			startDate: dto.start_date ? DateTime.fromISO(dto.start_date) : null,
			dueDate: dto.due_date ? DateTime.fromISO(dto.due_date) : null,
			createdAt: dto.created_at ? DateTime.fromISO(dto.created_at) : null,
			updatedAt: dto.updated_at ? DateTime.fromISO(dto.updated_at) : null,
			subtotal: dto.subtotal,
			total: dto.total,
			currency: dto.currency
				? InvoiceCurrencyMapper.toEntity(dto.currency.data)
				: undefined,
			integration: dto.integration ? dto.integration.data : undefined,
			billingData: dto.billing_data
				? BillingDataMapper.toEntity(dto.billing_data.data)
				: undefined,
		})
	}

	static toEntities(dtos: InvoiceResponseDTO[]): Invoice[] {
		return dtos.map(this.toEntity)
	}
}
